gsap.registerPlugin(ScrollTrigger);

let showcaseInstance = null;
let showcaseResizeTimeout = null;

document.addEventListener("DOMContentLoaded", () => {
    buildShowcase();
    window.addEventListener("resize", handleShowcaseResize);
});

function buildShowcase() {
    if (showcaseInstance) {
        showcaseInstance.destroy();
        showcaseInstance = null;
    }

    showcaseInstance = new ShowcaseImages({
        selector: ".el-preview__item__effect",
        debug: false,
        mobileBreakpoint: 767
    });
}

function handleShowcaseResize() {
    clearTimeout(showcaseResizeTimeout);

    showcaseResizeTimeout = setTimeout(() => {
        if (showcaseInstance?.safeRefresh) {
            showcaseInstance.safeRefresh();
        }
    }, 180);
}

class ShowcaseImages {
    constructor(options = {}) {
        this.selector = options.selector || ".el-preview__item__effect";
        this.debug = options.debug ?? false;
        this.mobileBreakpoint = options.mobileBreakpoint ?? 767;

        this.lenis = null;
        this.showcaseCtx = null;
        this.mm = gsap.matchMedia();

        this._rafId = null;
        this._isDestroyed = false;
        this._boundOnLenisScroll = null;
        this._boundPageShowHandler = null;
        this._boundLoadHandler = null;
        this._isMobileDisabled = false;

        this.init();
    }

    init() {
        this._isMobileDisabled = window.innerWidth <= this.mobileBreakpoint;

        if (this._isMobileDisabled) {
            return;
        }
        this.initLenis();
        this.initPreviewParallax();
        this.finalizeStartup();
    }

    initLenis() {

        if (!window.Lenis) return;

        this.lenis = new Lenis({
            lerp: 0.05,
            smooth: true,
            smoothTouch: false,
            prevent: (node) => {
                return !!node.closest(
                    ".menu-overlay__inner, .ts-dropdown, .ts-dropdown-content, .ts-control, .ts-wrapper, .choices, .choices__inner, .choices__list--dropdown, .choices__list[aria-expanded]"
                );
            }
        });

        this._boundOnLenisScroll = () => ScrollTrigger.update();
        this.lenis.on("scroll", this._boundOnLenisScroll);

        const raf = (time) => {
            if (this._isDestroyed || !this.lenis) return;
            this.lenis.raf(time);
            this._rafId = requestAnimationFrame(raf);
        };

        this._rafId = requestAnimationFrame(raf);

        ScrollTrigger.scrollerProxy(document.body, {
            scrollTop: (value) => {
                if (value != null) {
                    this.lenis.scrollTo(value, { immediate: true });
                    return;
                }
                return this.lenis.scroll;
            },
            getBoundingClientRect: () => ({
                top: 0,
                left: 0,
                width: window.innerWidth,
                height: window.innerHeight
            }),
            pinType: document.body.style.transform ? "transform" : "fixed"
        });
    }

    initPreviewParallax() {
        if (this.showcaseCtx) {
            this.showcaseCtx.revert();
            this.showcaseCtx = null;
        }

        this.showcaseCtx = gsap.context(() => {
           // this.mm.add("(min-width: 768px)", () => {
                const items = gsap.utils.toArray(this.selector);

// iPad / Tablet: nur jedes zweite Element animieren
            const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;
            const activeItems = isTablet ? items.filter((_, i) => i % 2 === 0) : items;
            activeItems.forEach((item, i) => {
                const img = item.querySelector(".el-preview__img");
                if (!img) return;

                let p = parseFloat(item.dataset.parallax);
                if (isNaN(p)) p = 12;
                p = gsap.utils.clamp(6, 40, p);

                // iPad schwächer
                if (isTablet) {
                    p *= 0.55;
                }

                gsap.set(img, { yPercent: -50 });

                gsap.fromTo(
                    img,
                    { yPercent: -50 - p },
                    {
                        yPercent: -50 + p,
                        ease: "none",
                        immediateRender: false,
                        scrollTrigger: {
                            id: `preview-parallax-${i}`,
                            trigger: item,
                            start: "top 90%",
                            end: "bottom 10%",
                            scrub: true,
                            invalidateOnRefresh: true,
                            markers: this.debug
                        }
                    }
                );
            });
           // });
        });
    }

    safeRefresh() {
        if (this._isDestroyed) return;

        if (this.lenis) this.lenis.stop();

        requestAnimationFrame(() => {
            ScrollTrigger.refresh(true);
            if (this.lenis) this.lenis.start();
        });
    }

    finalizeStartup() {
        const doFinal = () => {
            if (this._isDestroyed || !this.lenis) return;

            this.lenis.stop();
            this.lenis.scrollTo(0, { immediate: true });
            window.scrollTo(0, 0);

            gsap.delayedCall(0.1, () => {
                if (this._isDestroyed) return;
                ScrollTrigger.refresh(true);
                this.lenis?.start();
            });
        };

        this._boundPageShowHandler = (e) => {
            if (e.persisted) doFinal();
        };

        this._boundLoadHandler = () => {
            doFinal();
        };

        window.addEventListener("pageshow", this._boundPageShowHandler);
        window.addEventListener("load", this._boundLoadHandler, { once: true });
    }

    destroy() {
        this._isDestroyed = true;

        if (this._rafId) {
            cancelAnimationFrame(this._rafId);
            this._rafId = null;
        }

        if (this._boundPageShowHandler) {
            window.removeEventListener("pageshow", this._boundPageShowHandler);
        }

        if (this._boundLoadHandler) {
            window.removeEventListener("load", this._boundLoadHandler);
        }

        if (this.showcaseCtx) {
            this.showcaseCtx.revert();
            this.showcaseCtx = null;
        }

        if (this.mm) {
            this.mm.revert();
        }

        if (this.lenis) {
            this.lenis.destroy();
            this.lenis = null;
        }

        ScrollTrigger.getAll().forEach((st) => st.kill());
    }
}